/**
 *
 * Main locale file for this CRA. Determines which locale to be used on render.
 *
 * ! Keys across all locale files must be in sync
 */

import { Strings as en_us } from "./en-us";
import { Strings as zh_tw } from "./zh-tw";

const currentLocale = "zh-tw";

function getLocaleStrings() {
  const getCurrentLocale = () => {
    switch (currentLocale) {
      case "en-us":
        return en_us;
      case "zh-tw":
        return zh_tw;
      default:
        return en_us;
    }
  };

  return getCurrentLocale();
}

export default getLocaleStrings();
